"use strict";

var _ = require(".");
var _sampleEvent = _interopRequireDefault(require("./sampleEvent.json"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
async function main() {
  await (0, _.handler)(_sampleEvent.default);
}
main();